import { AxiosResponse } from "axios";
import { httpClient } from "./API";
import { QuickChargerRemainingTime, SearchQuickChargerRemainingTime } from "@/models/quickChargerRemainingTime";

export const getQuickChargerRemainingTimeAPI = async (
  search: SearchQuickChargerRemainingTime
): Promise<AxiosResponse<QuickChargerRemainingTime[]>> => {
  return httpClient.get("core/internal/calgary/chargingStatus/", {
    params: { ...search },
  });
};
